/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite';
import { BrandColors, Header } from '@blend/enterprise-components';

import { MeContext } from 'blb-contexts/Me';
import { dashboardHorizontalPadding } from 'blb-styles/constants';
import { OpsUserStatsReport } from './OpsUserStatsReport/OpsUserStatsReport';

export const styles = StyleSheet.create({
  header: {
    borderBottom: `1px solid ${BrandColors.CLOUD_50}`,
    paddingBottom: '32px',
    paddingLeft: '20px',
    paddingRight: dashboardHorizontalPadding,
    paddingTop: '32px',
  },
  statsPageContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

export const StatsPage: React.FC<Record<string, unknown>> = () => {
  const me = useContext(MeContext);
  if (me?.principalType !== 'ops_desk_agent') {
    return <Redirect to={'/pipeline'} />;
  }

  return (
    <div className={`${css(styles.statsPageContainer)}`}>
      <header className={`${css(styles.header)} statsHeader`} id="it-stats-header">
        <Header size={2}>Stats Dashboard</Header>
      </header>
      <OpsUserStatsReport />
    </div>
  );
};
